/**
 * Auto-sync Installation Addon with Slat Kit quantities
 * Permanent feature - keeps installation addon quantity matching slat kits
 * For toronto.alfredslats.com
 */

(function() {
  'use strict';

  const CONFIG = {
    triggerProductTitle: 'Alfred Slat Kit',
    installVariantId: '51365904679223',
    syncDelay: 400  // Delay before syncing
  };

  let isProcessing = false;

  async function getCartData() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Failed to fetch cart');
      const cart = await response.json();
      
      const slatKitItem = cart.items.find(item => 
        item.product_title === CONFIG.triggerProductTitle
      );
      const slatKitQty = slatKitItem ? slatKitItem.quantity : 0;
      
      const installItem = cart.items.find(item =>
        item.variant_id === parseInt(CONFIG.installVariantId)
      );
      const installQty = installItem ? installItem.quantity : 0;

      return { 
        slatKitQty, 
        installQty,
        hasSlatKit: slatKitQty > 0
      };
    } catch (error) {
      console.error('[Installation Addon] Error fetching cart:', error);
      return { 
        slatKitQty: 0, 
        installQty: 0,
        hasSlatKit: false
      };
    }
  }

  async function forceReloadCartDrawer() {
    // Wait briefly for Shopify to finish updating cart
    await new Promise(resolve => setTimeout(resolve, 200));
    
    // If on cart page, reload the entire page
    if (window.location.pathname === '/cart') {
      console.log('[Installation Addon] Reloading cart page');
      window.location.reload();
      return;
    }
    
    // Force the cart drawer to reload
    try {
      const response = await fetch(window.location.pathname + '?sections=cart-drawer');
      const data = await response.json();
      
      if (data && data['cart-drawer']) {
        const cartDrawerContent = document.querySelector('#cart-drawer-content');
        if (cartDrawerContent) {
          const temp = document.createElement('div');
          temp.innerHTML = data['cart-drawer'];
          const newContent = temp.querySelector('#cart-drawer-content');
          if (newContent) {
            cartDrawerContent.innerHTML = newContent.innerHTML;
            console.log('[Installation Addon] Cart drawer reloaded');
          }
        }
      }
    } catch (error) {
      console.log('[Installation Addon] Could not reload cart drawer:', error);
    }
  }

  async function syncInstallation() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const { slatKitQty, installQty, hasSlatKit } = await getCartData();

      // Check if founder bundle exists in cart
      const cart = await fetch('/cart.js').then(r => r.json());
      const bundleItem = cart.items.find(item => item.handle === 'founding-member-bundle');
      const hasFounderBundle = !!bundleItem;

      // If founder bundle is present, let the founder bundle script handle installation sync
      // This ensures both update at the same time
      if (hasFounderBundle) {
        console.log('[Installation Addon] Founder bundle present, deferring to founder script');
        isProcessing = false;
        return;
      }

      console.log(`[Installation Addon] Slat Kits: ${slatKitQty}, Installation: ${installQty}`);

      // Check if installation addon checkbox is checked on product page
      const installCheckbox = document.getElementById('alfred-install-addon');
      const isCheckboxChecked = installCheckbox ? installCheckbox.checked : false;
      
      // Determine if user wants installation
      // Either: checkbox is checked OR installation is already in cart (user added it before)
      const userWantsInstallation = isCheckboxChecked || installQty > 0;

      // Case 1: No slat kits - remove installation addon
      if (!hasSlatKit && installQty > 0) {
        console.log('[Installation Addon] Removing installation addon (no slat kits)');
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [CONFIG.installVariantId]: 0 } })
        });
        await forceReloadCartDrawer();
        isProcessing = false;
        return;
      }

      // Case 2: User doesn't want installation - remove it if present
      if (!userWantsInstallation && installQty > 0) {
        console.log('[Installation Addon] Removing installation addon (user unchecked)');
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [CONFIG.installVariantId]: 0 } })
        });
        await forceReloadCartDrawer();
        isProcessing = false;
        return;
      }

      // Case 3: User wants installation - sync quantity with slat kits
      if (userWantsInstallation && hasSlatKit && installQty !== slatKitQty) {
        if (installQty > slatKitQty) {
          console.log(`[Installation Addon] Capping from ${installQty} to ${slatKitQty} (can't exceed walls)`);
        } else {
          console.log(`[Installation Addon] Syncing from ${installQty} to ${slatKitQty}`);
        }
        
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [CONFIG.installVariantId]: slatKitQty } })
        });
        
        await forceReloadCartDrawer();
      }

    } catch (error) {
      console.error('[Installation Addon] Error:', error);
    }

    isProcessing = false;
  }

  function init() {
    console.log('[Installation Addon] Initialized - syncs installation with slat kits');

    // Initial check
    setTimeout(syncInstallation, CONFIG.syncDelay);

    // ✅ NEW: Watch for cart drawer opening
    const cartDrawerElement = document.querySelector('cart-drawer') || 
                             document.querySelector('[data-cart-drawer]') ||
                             document.querySelector('.cart-drawer');
    
    if (cartDrawerElement) {
      const drawerObserver = new MutationObserver((mutations) => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            if (cartDrawerElement.classList.contains('is-open') || 
                cartDrawerElement.classList.contains('active')) {
              console.log('[Installation Addon] 🚪 Drawer opened - checking sync');
              // Check if sync is needed, then refresh if necessary
              setTimeout(async () => {
                const { slatKitQty, installQty } = await getCartData();
                if (slatKitQty !== installQty) {
                  console.log('[Installation Addon] Quantities out of sync, syncing now');
                  syncInstallation();
                }
              }, 100);
            }
          }
        }
      });
      
      drawerObserver.observe(cartDrawerElement, { 
        attributes: true, 
        attributeFilter: ['class'] 
      });
      
      console.log('[Installation Addon] ✅ Watching cart drawer for opens');
    }

    // Monitor cart changes
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const promise = originalFetch.apply(this, args);
      
      if (args[0] && (
        args[0].includes('/cart/add') || 
        args[0].includes('/cart/change') || 
        args[0].includes('/cart/update')
      )) {
        promise.then(() => {
          setTimeout(syncInstallation, 500);
        });
      }
      
      return promise;
    };

    // Periodic check every 3 seconds
    setInterval(syncInstallation, 3000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
